// extracted by mini-css-extract-plugin
export default {"IFButton":"IFButton_IFButton__fz-v8","fill":"IFButton_fill__iVaZk","filled":"IFButton_filled__GQSj5","IconContainer":"IFButton_IconContainer__fFSiN"};